import type React from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconPauseCircleFilled, iconPlayCircleFilled } from '@change-corgi/design-system-legacy/icons';

import { isIPhone } from 'src/app/shared/utils/userAgent';

export const PlayPauseIcons: React.FC<{ isPlaying: boolean }> = ({ isPlaying }) => {
	const utilityContext = useUtilityContext();
	const iPhone = isIPhone(utilityContext);
	const icon = !iPhone && isPlaying ? iconPauseCircleFilled : iconPlayCircleFilled;

	return (
		<Icon
			icon={icon}
			size="xxxl"
			sx={{
				background: 'radial-gradient(circle at center, white 30%, transparent 50%)',
				opacity: 0.7,
				position: 'absolute',
				bottom: '10px',
				zIndex: 1,
				pointerEvents: 'none',
			}}
			data-testid={icon === iconPlayCircleFilled ? 'playIcon' : 'pauseIcon'}
		/>
	);
};
